import ACTIONS from "../actions/types";
const initialState = {
  organizations: [],
  isFetchingGroups: true,
  selectedOrgHasNoGroup: false,
  orgGroups: [],
  selectedOrganization: null,

  currntActiveMode: "DataAnalytics",
  // currntActiveMode: "Scheduling",
  selectedOrgGroupsList: [],
  constAnalyticsRefsList: [],
  constAnalyticsPeriodsList: [],
  selectedGroup: null,
  selectedRef: null,
  selectedPeriod: null,
  selectedDate: null,
  isFetchingOrganizations: true,
  trendsDevicesDataList: [],
  devicesWithDetailsList: [],
  compareSelectedDevicesList: [],
  isFetchCompareData: false,
  compareSelectedDevicesListData: []
};

const CounterDashboardReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case ACTIONS.TRENDS.GET_ALL_ORGNANIZATION:
      return {
        ...state,
        isFetchingGroups: false,
        organizations: payload,
        isFetchingOrganizations: false
      };

    case ACTIONS.TRENDS.START_FETCHING_GROUPS:
      return {
        ...state,
        isFetchingGroups: payload
      };

    case ACTIONS.TRENDS.SET_CURRENT_ACTIVE_MODE:
      return {
        ...state,
        currntActiveMode: payload
      };

    case ACTIONS.TRENDS.SET_SELECTED_ORGNANIZATION:
      return {
        ...state,
        isFetchingGroups: true,
        selectedOrgHasNoGroup: true,
        selectedOrganization: payload
      };

    case ACTIONS.TRENDS.GET_ORGANIZATION_GROUPS:
      return {
        ...state,
        isFetchingGroups: false,
        orgGroups: payload,
        selectedOrgGroupsList: payload,
        selectedOrgHasNoGroup: false
      };
    case ACTIONS.TRENDS.CLEAR_GROUPS_LIST:
      return {
        ...state,
        // isFetchingGroups: true,
        // selectedOrgHasNoGroup: true,
        orgGroups: [],
        selectedOrgGroupsList: []
      };
    case ACTIONS.SERVICE_SCHEDULES.GET_ORGANIZATION_GROUPS:
      return {
        ...state,
        isFetchingGroups: false,
        orgGroups: payload,
        selectedOrgGroupsList: payload,
        selectedOrgHasNoGroup: false
      };

    case ACTIONS.TRENDS.SELECTED_ORGANIZATION_HAS_NO_GROUPS:
      return {
        ...state,
        isFetchingGroups: false,
        selectedOrgHasNoGroup: true,
        orgGroups: []
      };

    case ACTIONS.CONSTS.ANALYTICS.REF_LOAD:
      return {
        ...state,
        constAnalyticsRefs: payload
      };

    case ACTIONS.CONSTS.ANALYTICS.PERIOD_LOAD:
      return {
        ...state,
        constAnalyticsPeriods: payload
      };

    case ACTIONS.TRENDS.SET_REF_LIST:
      return {
        ...state,
        constAnalyticsRefsList: payload
      };

    case ACTIONS.TRENDS.SET_PERIOD_LIST:
      return {
        ...state,
        constAnalyticsPeriodsList: payload
      };

    case ACTIONS.TRENDS.SELECTED_GROUP:
      return {
        ...state,
        selectedOrgGroupsList: [...payload]
      };

    case ACTIONS.TRENDS.SELECTED_REF:
      return {
        ...state,
        selectedRef: payload
      };

    case ACTIONS.TRENDS.SELECTED_PERIOD:
      return {
        ...state,
        selectedPeriod: payload
      };

    case ACTIONS.TRENDS.SELECTED_DATE:
      return {
        ...state,
        selectedDate: payload
      };

    case ACTIONS.TRENDS.SET_SELECTED_CURRENT_ACTIVE_MODE:
      return {
        ...state,
        currntActiveMode: payload
      };

    case ACTIONS.TRENDS.SET_ALL_TRENDS_DEVICES_TO_FETCH:
      return {
        ...state,
        orgGroups: payload
      };

    case ACTIONS.TRENDS.UPDATE_ALL_TRENDS_DEVICES_DATA:
      return {
        ...state,
        orgGroups: payload
      };

    case ACTIONS.TRENDS.UPDATE_ONE_TRENDS_DEVICES_DATA:
      return {
        ...state,
        orgGroups: payload
      };
    case ACTIONS.SERVICE_SCHEDULES.UPDATE_ONE_SERVICE_SCHEDULES_DEVICES_DATA:
      return {
        ...state,
        orgGroups: payload
      };

    case ACTIONS.TRENDS.REMOVE_FROM_TRENDS_DEVICES:
      return {
        ...state,
        orgGroups: payload
      };

    case ACTIONS.TRENDS.UPDATE_DEVICES_WITH_DETAILS_LIST:
      return {
        ...state,
        devicesWithDetailsList: payload
      };
    case ACTIONS.SERVICE_SCHEDULES.UPDATE_DEVICE_THRESHOLD:
      return {
        ...state,
        orgGroups: payload
      };
    case ACTIONS.SERVICE_SCHEDULES.RESET_SERVICE_SCHEDULES:
      return {
        ...state,
        orgGroups: payload
      };
    case ACTIONS.COMPARE.SET_SELECTED_DEVICES_LIST:
      return {
        ...state,
        compareSelectedDevicesList: payload
      };

    case ACTIONS.COMPARE.FETCH_SELECTED_DEVICES_LIST_DATA:
      return {
        ...state,
        isFetchCompareData: payload
        // compareSelectedDevicesListData: []
      };

    case ACTIONS.COMPARE.SET_SELECTED_DEVICES_LIST_DATA:
      return {
        ...state,
        isFetchCompareData: false,
        compareSelectedDevicesListData: payload
      };

    default:
      return state;
  }
};
export default CounterDashboardReducer;
